<template>
  <BContainer
    fluid
  />
</template>
<script>
import { core } from '@/config/pluginInit'

export default {
  name: 'VAuditDashboard',

  middleware: ['auth', 'audit'],

  metaInfo () {
    return {
      title: 'Dashboard'
    }
  },

  mounted () {
    core.index()
  }
}
</script>
